import {
  type BidDomainSelectModel,
  BidId,
  BidStatuses,
  BidUrn,
  OrganizationId,
  ProjectId,
  TeamId,
} from '@mntn-dev/domain-types'
import { calculateCostPlusMargin } from '@mntn-dev/finance'
import { getRandomItem } from '@mntn-dev/utilities'
import { MockModel } from './mock-model.ts'

export const MockBid = MockModel<BidDomainSelectModel>(
  ({
    bidId = BidId(),
    bidUrn = BidUrn(bidId),
    projectId = ProjectId(),
    agencyOrganizationId = OrganizationId(),
    agencyTeamId = TeamId(),
    status = getRandomItem(BidStatuses),
    revision = 0,
    amount,
    costMarginPercent = 50,
  }) => {
    return {
      bidId,
      bidUrn,
      projectId,
      agencyOrganizationId,
      agencyTeamId,
      status,
      amount,
      costMarginPercent,
      amountPlusMargin:
        amount && calculateCostPlusMargin(amount, costMarginPercent),
      revision,
    } satisfies BidDomainSelectModel
  }
)
